import { RelatedPersonVm } from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';
import RelatedPersonRow from './RelatedPersonRow';
import { InfoCard, InfoCardHeader } from '@/components/ui/InfoCard.tsx';
import { peopleCountLabel } from '@/features/dashboard/bookingChanges/components/bookingDetails/bookingHeaderPresentation.ts';

interface RelatedPeopleCardProps extends React.HTMLAttributes<HTMLDivElement> {
  people: RelatedPersonVm[];
}

/**
 * Karta „Powiązane osoby” — cała obsada rezerwacji z jednym kliknięciem do
 * każdej.
 */
const RelatedPeopleCard = ({ people, ...props }: RelatedPeopleCardProps) => (
  <InfoCard {...props}>
    <InfoCardHeader
      title="Powiązane osoby"
      aside={
        <span className="text-xs font-semibold text-neutral-400">
          {peopleCountLabel(people)}
        </span>
      }
    />

    <div className="flex flex-col px-5 pb-3.5 pt-2">
      {people.map((entry, index) => (
        <RelatedPersonRow
          key={entry.person.id}
          entry={entry}
          isFirst={index === 0}
        />
      ))}
    </div>
  </InfoCard>
);

export default RelatedPeopleCard;
